/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state

==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, {colors} from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  id: '',
  first_name: '',
  last_name: '',
  username: '',
  email: '',
  profile_picture: 'https://portal-cdn.rapid.education/profile-pictures/default.jpeg',
  role: ''
}
const userInfoLocalStorage = JSON.parse(localStorage.getItem('userInfo')) || {}
const getUserInfo = () => {
  const userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null) userInfo[key] = userInfoLocalStorage[key]
  })

  userInfo['full_name'] = `${userInfo.first_name} ${userInfo.last_name}`

  return userInfo
}

const courseDefaults = {
  selected: '',
  id: '',
  name: 'No Course Selected',
  description: '',
  retailer_id: '',
  status: '',
  thumbnail: '',
  simulations: []
}
const courseInfoLocalStorage = JSON.parse(localStorage.getItem('courseInfo')) || {}
const getActiveCourse = () => {
  const courseInfo = courseDefaults

  // Update property in user
  Object.keys(courseDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    courseInfo[key] = courseInfoLocalStorage[key] ?  courseInfoLocalStorage[key] : courseInfo[key]
  })

  // Include properties from localStorage
  Object.keys(courseInfoLocalStorage).forEach((key) => {
    if (courseInfo[key] === undefined && courseInfoLocalStorage[key] !== null) courseInfo[key] = courseInfoLocalStorage[key]
  })
  return courseInfo
}

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const isTouchDevice = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if ('ontouchstart' in window || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}

// Audio Settings
const audioDefaults = {
  backgroundMusic: false,
  backgroundSong: 'default',
  soundEffects: true
}
const audioSettingsLocalStorage = JSON.parse(localStorage.getItem('audioSettings')) || {}
const getAudioSettings = () => {
  const audioSettings = audioDefaults

  // Update property in user
  Object.keys(audioDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    audioSettings[key] = audioSettingsLocalStorage[key] ?  audioSettingsLocalStorage[key] : audioSettings[key]
  })

  // Include properties from localStorage
  Object.keys(audioSettingsLocalStorage).forEach((key) => {
    if (audioSettings[key] === undefined && audioSettingsLocalStorage[key] !== null) audioSettings[key] = audioSettingsLocalStorage[key]
  })
  return audioSettings
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser: getUserInfo(),
  AppActiveCourse: getActiveCourse(),
  AudioSettings: getAudioSettings(),
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  isTouchDevice: isTouchDevice(),
  mainLayoutType: themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: 'default',
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme: themeConfig.theme || 'light',
  themePrimaryColor: colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
}

export default state
